var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b4e6c0;\n      }\n\n      .cls-2 {\n        fill: #b4e6c1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.5,39.3c-4.7,0-9.4,0-14.1,0-3.2,0-4.6-1.3-4.6-4.4,0-5.3,0-10.7,0-16,0-2.3.4-2.5,2.5-1.3,4.8,2.9,9.6,5.8,14.3,8.9,1.6,1,2.9,1,4.4,0,4.4-2.8,8.8-5.6,13.3-8.4.6-.4,1.2-.7,1.9-1,1.3-.5,2-.2,1.9,1.3,0,5.6,0,11.2,0,16.7,0,2.6-1.8,4.2-4.5,4.2-5,0-10,0-15.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.9,8.7c4.7,0,9.4,0,14.1,0,1,0,1.9,0,2.8.5,1.9,1,2.1,2.3.2,3.5-5.1,3.3-10.3,6.6-15.4,9.9-.9.6-1.9.7-2.9.1-5.5-3.4-11.1-6.8-16.6-10.2-1-.6-1-1.6-.2-2.5.8-1,2-1.2,3.2-1.2,4.9,0,9.9,0,14.8,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d4079fee683a1db3ddd75f515acaff06.svg";
export { ForwardRef as ReactComponent };